@if (appSettings.isMobile()) {
    <!-- Vista Móvil: Barra limpia y minimalista de navegación por pasos -->
    <div class="timeline-mobile-clean mb-3">
        <div class="d-flex align-items-center justify-content-between px-2">
            <button type="button"
                    (click)="prevStep($event)"
                    class="btn btn-link text-body p-0 border-0 timeline-nav-arrow"
                    [disabled]="!canPrev()"
                    [attr.aria-disabled]="!canPrev()"
                    title="Paso anterior">
                <i class="fas fa-chevron-left fs-15"></i>
            </button>

            <div class="text-center px-2 text-truncate flex-grow-1">
                <div class="fw-bold text-dark text-truncate d-flex align-items-center justify-content-center gap-2" style="font-size: 0.95rem;">
                    @if (currentStepIcon()) {
                        <i [class]="currentStepIcon() + ' text-primary'"></i>
                    }
                    <span>{{ currentStepTitle() }}</span>
                </div>
                <div class="d-flex align-items-center justify-content-center gap-1 mt-1">
                    @for (s of steps(); track s.id) {
                        <span class="step-dot"
                              role="button"
                              tabindex="0"
                              [class.active]="isActive(s.id)"
                              [class.completed]="isCompleted(s.id)"
                              [class.disabled]="isDisabled(s.id)"
                              (click)="onStepClick(s.id, $event)"
                              (keydown.enter)="onStepClick(s.id, $event)"
                              (keydown.space)="onStepClick(s.id, $event)"></span>
                    }
                </div>
            </div>

            <button type="button"
                    (click)="nextStep($event)"
                    class="btn btn-link text-body p-0 border-0 timeline-nav-arrow"
                    [disabled]="!canNext()"
                    [attr.aria-disabled]="!canNext()"
                    title="Paso siguiente">
                <i class="fas fa-chevron-right fs-15"></i>
            </button>
        </div>
    </div>
} @else {
    <!-- Vista Desktop: Wizard completo de píldoras idéntico al original -->
    <div class="nav-wizards-container mb-2">
        <nav class="nav nav-wizards-2">
            @for (step of steps(); track step.id) {
            <div class="nav-item col">
                <a class="nav-link" [ngClass]="{
                       'completed': isCompleted(step.id),
                       'active': isActive(step.id),
                       'disabled': isDisabled(step.id)
                   }"
                   href="javascript:;"
                   [attr.aria-current]="isActive(step.id) ? 'step' : null"
                   [attr.aria-disabled]="isDisabled(step.id)"
                   (click)="onStepClick(step.id, $event)">
                    <div class="nav-text">{{ step.title }}</div>
                </a>
            </div>
            }
        </nav>
    </div>
}
